import {
  Component, EventEmitter, Output,
} from '@angular/core';
import { ModalService } from '@services/modal.service';

@Component({
  selector: 'app-modal-signature-request',
  templateUrl: './modal-signature-request.component.html',
  styleUrls: ['./modal-signature-request.component.scss']
})
export class ModalSignatureRequestComponent {
  @Output() finish: EventEmitter<object> = new EventEmitter<object>();

  constructor(
    public modal: ModalService,
  ) { }

  ngOnDestroy() {
    this.modal.close();
  }

  finishRequest() {
    this.modal.close();
    this.finish.emit();
  }

}